// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/lib/checkbox';
import React, { ReactElement } from 'react';

import './Group.scss';

type GroupProps = CheckboxGroupProps;

export const Group = ({ className, children, ...props }: GroupProps): ReactElement => (
    <Checkbox.Group className={classList('th-checkbox__group', className)} {...props}>
        {children}
    </Checkbox.Group>
);
